export default "__VITE_ASSET__TIXLltpm__"